// Unified index colour utility for the Active groups page.
//
// A pure function that maps any KPI index value to a Tailwind text-colour class,
// using the unified scheme shared by all index columns (Growth Index, Water Index,
// weight schedule index, mortality index):
//
//   ≤ 75   → red
//   76–99  → amber
//   ≥ 100  → green
//   null   → neutral (no colour)
//
// This module has no Vue or store dependencies so it can be consumed by any column
// renderer without side effects, and unit-tested in isolation.

// Tailwind text-colour classes for each index band.
export const INDEX_COLOUR_RED = 'text-red-600';
export const INDEX_COLOUR_AMBER = 'text-amber-600';
export const INDEX_COLOUR_GREEN = 'text-green-700';
export const INDEX_COLOUR_NEUTRAL = '';

export const INDEX_BG_RED = 'bg-[#DC2626]';
export const INDEX_BG_AMBER = 'bg-[#E8913A]';
export const INDEX_BG_GREEN = 'bg-[#1B9E5F]';

export function indexColourClass(index: number | null): string {
    if (index === null) return INDEX_COLOUR_NEUTRAL;
    if (index <= 75) return INDEX_COLOUR_RED;
    if (index < 100) return INDEX_COLOUR_AMBER;
    return INDEX_COLOUR_GREEN;
}

export function indexBgColourClass(value: number): string {
    if (value <= 75) return INDEX_BG_RED;
    if (value < 100) return INDEX_BG_AMBER;
    return INDEX_BG_GREEN;
}
